"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analyticsUtils = _interopRequireDefault(require("../analytics-integrations/analytics-utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var pendingReviewWithSnoozeViewed = function pendingReviewWithSnoozeViewed(properties) {
  if (!_analyticsUtils.default.segmentLoaded()) return;
  analytics.track('review_modal_loaded_by_host', properties);
};
var snoozeButtonPressed = function snoozeButtonPressed(count, deviceType, ssoid, bookingId) {
  if (!_analyticsUtils.default.segmentLoaded()) return;
  var properties = {
    count: count,
    deviceType: deviceType,
    ssoid: ssoid,
    bookingId: bookingId
  };
  analytics.track('snooze review clicked', properties);
};
var _default = exports.default = {
  pendingReviewWithSnoozeViewed: pendingReviewWithSnoozeViewed,
  snoozeButtonPressed: snoozeButtonPressed
};